// A diagnostic identifier for this page load, shared across authentication refreshes.
// It is never persisted or used as proof of identity.
let clientRequestId: string | undefined

export function getClientRequestId(): string {
  return (clientRequestId ??= crypto.randomUUID())
}

// A page-local once flag for each Clerk session, shared by concurrent access checks.
const associatedSessions = new Set<string>()

export async function withIdentityAssociation<T extends { status: number }>(
  sessionId: string | null | undefined,
  send: (headers: Record<string, string>) => Promise<T>,
): Promise<T> {
  if (!sessionId || associatedSessions.has(sessionId)) return send({})
  associatedSessions.add(sessionId)
  let succeeded = false
  try {
    const response = await send({ "X-Vivid-Log-Association": "1" })
    succeeded = (response.status >= 200 && response.status < 300) || response.status === 304
    return response
  } finally {
    if (!succeeded) associatedSessions.delete(sessionId)
  }
}
